import React, {Component} from 'react';
import CurrencyInput from 'react-currency-input';
import t from 'tcomb-form';

const MAX_CURRENCY = 1000 * 1000 * 1000;

export default class FormCurrencyFloatInput extends Component {
    static displayName = 'FormCurrencyFloatInput';

    getValidationOptions() {
        return {
            path: this.props.ctx.path,
            context: t.mixin(t.mixin({}, this.props.context || this.props.ctx.context), {
                options: this.props.options
            })
        };
    }

    handleInputChange = (maskedValue, floatValue) => {
        if (floatValue <= MAX_CURRENCY) {
            this.props.onChange(floatValue);
        } else {
            this.setState({});
        }
    };

    validate() {
        const {value} = this.props;
        return t.validate(value, this.props.type, this.getValidationOptions());
    }

    render() {
        const {options, placeholder, value} = this.props;

        return (
            <div className="form-group">
                {options.label}
                <CurrencyInput
                    value={value}
                    onChange={this.handleInputChange}
                    placeholder={placeholder}
                    precision={2}
                    prefix="$"
                    className="input-sm form-control"
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./form_components/form_currency_float_input.js